const DescriptionsItem = _ref => {
  let {
    children
  } = _ref;
  return children;
};
export default DescriptionsItem;